import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getUI } from 'redux/selectors';
import { updateUI } from 'redux/actions/ui';
import * as JournalActions from 'redux/actions/journal';
import './MissionStartDateStatusDialog.css';
import iconCalendar from 'assets/images/icons_svg/icon_mission_calendar.svg';
import iconCaretDown from 'assets/images/icons_svg/icon_caret-down.svg';

const MissionStartDateStatusDialog = ({
    close,
    dispatch,
    journal // the active mission journal object, passed as prop when opening dialog
}) => {
    // Normalise date to YYYY-MM-DD (the API may return a full ISO timestamp)
    const toDateInputValue = (dateStr) => {
        if (!dateStr) {
            return '';
        }
        return dateStr.split('T')[0];
    };

    const missionStartDate = toDateInputValue(journal?.mission_start_date);
    const [missionStatus, setMissionStatus] = useState(
        journal?.missionary_status || ''
    );
    const [isSaving, setIsSaving] = useState(false);

    const _close = useCallback(() => {
        if (close) {
            close();
        } else {
            dispatch(updateUI({ dialogs: [] }));
        }
    }, [close, dispatch]);

    const _onSave = useCallback(() => {
        if (!journal?.id) {
            _close();
            return;
        }
        setIsSaving(true);
        dispatch(
            JournalActions.update({
                id: journal.id,
                mission_start_date: missionStartDate || null,
                missionary_status: missionStatus // correct API field name
            })
        )
            .then(() => {
                setIsSaving(false);
                _close();
            })
            .catch(() => {
                setIsSaving(false);
                _close();
            });
    }, [dispatch, journal, missionStartDate, missionStatus, _close]);

    return (
        <div
            id="mission-start-date-status-modal"
            className="modal-frame centered-modal-frame">
            <div className="modal-box modal-box--start-status">
                {/* Header */}
                <div className="modal__header msds-header">
                    Mission Start Date &amp; Status
                </div>

                {/* Body */}
                <div className="modal__body msds-body">
                    <div className="msds-fields-row">
                        {/* Mission Status */}
                        <div className="msds-form-group">
                            <label className="msds-label">Mission Status</label>
                            <div className="msds-dropdown-wrapper">
                                <select
                                    className={`msds-select ${
                                        !missionStatus
                                            ? 'msds-placeholder-active'
                                            : ''
                                    }`}
                                    value={missionStatus}
                                    onChange={(e) =>
                                        setMissionStatus(e.target.value)
                                    }>
                                    <option value="" disabled>
                                        Choose one
                                    </option>
                                    <option value="starting_the_mission">
                                        Starting the mission
                                    </option>
                                    <option value="currently_serving">
                                        Currently serving
                                    </option>
                                    <option value="ended_the_mission">
                                        Ended the mission
                                    </option>
                                </select>
                                <img
                                    src={iconCaretDown}
                                    alt=""
                                    className="msds-select-caret"
                                />
                            </div>
                        </div>

                        {/* Mission Start Date — calendar picker */}
                        <div className="msds-form-group">
                            <label className="msds-label">
                                Mission Start Date
                            </label>
                            <div className="msds-input-with-icon">
                                <img
                                    src={iconCalendar}
                                    alt=""
                                    className="msds-input-icon"
                                />
                                <input
                                    type="date"
                                    value={missionStartDate}
                                    className="msds-input msds-input--date msds-input--disabled"
                                    disabled
                                />
                            </div>
                            <span className="msds-field-hint">
                                This field is read-only and cannot be edited.
                            </span>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="modal__footer msds-footer">
                    <button className="msds-btn-cancel" onClick={_close}>
                        Close
                    </button>
                    <button
                        className="btn btn-gradient msds-btn-save"
                        onClick={_onSave}
                        disabled={isSaving}>
                        {isSaving ? 'Saving...' : 'Save & Close'}
                    </button>
                </div>
            </div>
        </div>
    );
};

const state = createStructuredSelector({
    ui: getUI
});

export default connect(state)(MissionStartDateStatusDialog);
